import axios from "../util/axiosConfig";
import { getErrorMessage } from "../util/ErrorUtils";

export const fetchDashboardCountAPI = async (data) => {
    return await axios
      .get(
        `/api/v1/dashboard-counts?role=${data.role.toLowerCase()}&mipId=${
          data.mipId
        }&filter=${data.filter}`
      )
      .then((response) => {
        if (response.data) {          
          return {
            success: true,
            data: response.data,
          };
        } else {
          return { success: false };
        }
      })
      .catch((error) => {
        return { success: false, error: getErrorMessage(error) };
      });
};

export const fetchDashboardAlertsAPI = async (mipId) => {
  return await axios
    .get(`/api/v1/receptionist/latest-alerts?mipId=${mipId}`)
    .then((response) => {        
      if (response.data) {
        return {
          success: true,
          data: response.data,
        };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
};

export const fetchStatOverviewToken = async (risCode) => {
  return await axios
    .get(`/api/v1/powerbi/token`, { params: { risCode } })
    .then((response) => {        
      if (response.data) {
        console.log('dataResponse', response.data)
        return {
          success: true,
          data: response.data,
        };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
};
